var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNegative(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.70094 0.36492L11.1209 0.36492C11.4534 0.364438 11.7791 0.458105 12.0605 0.635078C12.3419 0.812052 12.5674 1.06509 12.7109 1.36492C12.879 1.72066 12.9437 2.11645 12.8977 2.50719C12.8518 2.89792 12.6969 3.26789 12.4509 3.57492L8.24094 8.67492C8.07573 8.86555 7.87146 9.01844 7.64199 9.12322C7.41252 9.228 7.1632 9.28223 6.91094 9.28223C6.65868 9.28223 6.40937 9.228 6.17989 9.12322C5.95042 9.01844 5.74616 8.86555 5.58094 8.67492L1.37094 3.57492C1.12493 3.26789 0.970126 2.89792 0.924157 2.50719C0.878188 2.11645 0.942909 1.72066 1.11094 1.36492C1.25448 1.06509 1.48 0.812052 1.76139 0.635078C2.04278 0.458105 2.36853 0.364438 2.70094 0.36492Z",
    fill: "#B42318"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegative);
export default __webpack_public_path__ + "static/media/negative.55a14cc89c89343d4495661e13a76de2.svg";
export { ForwardRef as ReactComponent };